import DARAK_EXT_1 from "./DARAK_EXT_1";
export default {
  DARAK_EXT_1,
};
